"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputArquivo = exports.extensoesArray = void 0;
var estiloInputArquivo = require('./InputArquivo.module.scss');
var react_1 = __importStar(require("react"));
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var extensaoArquivosAceitos = ".pdf, .xlsx, .html ,.docx, .pptx, .txt, .csv, .jpg, .jpeg, .png, .gif, .bmp, .webp, .svg,";
exports.extensoesArray = extensaoArquivosAceitos
    .split(',')
    .map(function (ext) { return ext.trim(); })
    .filter(function (ext) { return ext !== ''; });
var InputArquivo = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, titulo = _a.titulo, _c = _a.placeholder, placeholder = _c === void 0 ? "Inserir Arquivo" : _c, anexos = _a.anexos, multiplosAnexos = _a.multiplosAnexos, formatoArquivo = _a.extensaoArquivo, _d = _a.variante, variante = _d === void 0 ? 'regular' : _d, _e = _a.tamanho, tamanho = _e === void 0 ? 'small' : _e, _f = _a.posicaoIcone, posicaoIcone = _f === void 0 ? 'left' : _f, conteudoDeAjuda = _a.conteudoDeAjuda, _g = _a.iconeInputField, iconeInput = _g === void 0 ? 'attach_file' : _g, desabilitado = _a.desabilitado, _h = _a.readonly, readonly = _h === void 0 ? false : _h, _j = _a.autofocus, autofocus = _j === void 0 ? false : _j, style = _a.style, onHover = _a.onHover, onChange = _a.onChange, onBlur = _a.onBlur, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus;
    var _k = (0, react_1.useState)([]), arquivo = _k[0], setArquivo = _k[1];
    var _l = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _l[0], setCor = _l[1];
    var _m = (0, react_1.useState)(placeholder), nomeArquivo = _m[0], setNomeArquivo = _m[1];
    var _o = (0, react_1.useState)('20px'), iconSize = _o[0], setIconSize = _o[1];
    var _p = (0, react_1.useState)('default'), tipoEstilo = _p[0], setTipoEstilo = _p[1];
    var iconPositionStyle = estiloInputArquivo[posicaoIcone];
    var disabledStyle = estiloInputArquivo.disabled;
    var varianteStyle = estiloInputArquivo[variante];
    var inputFieldSize = estiloInputArquivo[tamanho];
    var inputFieldStyle = desabilitado ? disabledStyle : varianteStyle;
    var tipoEstiloStyle = estiloInputArquivo[tipoEstilo];
    var inputFileRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (anexos && anexos.length > 0) {
            var dataTransfer = new DataTransfer();
            var file = anexos[0] instanceof File
                ? anexos[0]
                : new File([""], anexos[0].nome, { type: "application/octet-stream" });
            dataTransfer.items.add(file);
            if (inputFileRef.current) {
                inputFileRef.current.files = dataTransfer.files;
            }
            setNomeArquivo(anexos[0] instanceof File ? anexos[0].name : anexos[0].nome);
            setTipoEstilo("filled");
            setCor(Cores_1.Cores.GradacaoNeutros.BrancoMU50);
        }
    }, [anexos]);
    var handleChange = function (event) {
        var _a;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a.length))
            return;
        var arquivos = Array.from(event.target.files);
        var primeiroArquivo = arquivos[0];
        setArquivo([primeiroArquivo]);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.files);
    };
    var handleFileInputClick = function () {
        var inputElement = id ? document.getElementById(id) : null;
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.click();
    };
    (0, react_1.useEffect)(function () {
        switch (tamanho) {
            case 'small':
                setIconSize('16px');
                break;
            case 'medium':
                setIconSize('20px');
                break;
        }
    }, [tamanho]);
    (0, react_1.useEffect)(function () {
        setCor(globalMu_1.default.getCor({ desabilitado: desabilitado, tipoEstilo: tipoEstilo, variante: variante }));
    }, [variante, desabilitado]);
    var BotaoIcone = (react_1.default.createElement("div", { onMouseEnter: function () { return onHover && onHover(); }, className: "".concat(estiloInputArquivo.iconButton, " ").concat(tamanho, " ").concat(variante, " ").concat(desabilitado ? disabledStyle : '') }, iconeInput && react_1.default.createElement(Icone_1.Icone, { nome: iconeInput, cor: cor, largura: iconSize, altura: iconSize, style: { cursor: 'default' } })));
    var renderInputArquivo = (react_1.default.createElement("div", { className: "\n            ".concat(estiloInputArquivo.inputContainer, " \n            ").concat(posicaoIcone, " \n            ").concat(inputFieldSize, "\n            ").concat(inputFieldStyle, "\n            ").concat(tipoEstiloStyle, "\n        "), onClick: handleFileInputClick },
        react_1.default.createElement("div", { className: "".concat(estiloInputArquivo.inputField, " ").concat(tipoEstiloStyle, " ").concat(disabledStyle) },
            posicaoIcone === 'left' && BotaoIcone,
            react_1.default.createElement("input", { className: estiloInputArquivo.inputOculto, onChange: handleChange, onBlur: function (e) {
                    if (onBlur)
                        onBlur(e);
                }, accept: formatoArquivo, type: "file", disabled: desabilitado, placeholder: placeholder, name: name, id: id, readOnly: true, onClick: function (e) { return e.stopPropagation(); }, ref: inputFileRef, autoFocus: autofocus, onKeyUp: onKeyUp, onFocus: onFocus, multiple: multiplosAnexos }),
            react_1.default.createElement("span", null, multiplosAnexos ? anexos && anexos.length > 1 ? "".concat(anexos.length, " arquivos selecionados") : "Inserir Arquivo" : nomeArquivo),
            posicaoIcone === 'right' && BotaoIcone)));
    var estiloPredefinido = titulo || conteudoDeAjuda ? '8px' : '';
    return (react_1.default.createElement("div", { className: estiloInputArquivo.container, style: __assign({ gap: "".concat(estiloPredefinido) }, style) },
        titulo &&
            react_1.default.createElement(Label_1.Label, { texto: titulo, negrito: 700, estado: variante, desabilitado: true, htmlFor: "", obrigatorio: false }),
        renderInputArquivo,
        conteudoDeAjuda &&
            react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || '', desabilitado: desabilitado, estado: (_b = conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) !== null && _b !== void 0 ? _b : variante, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone })));
};
exports.InputArquivo = InputArquivo;
